<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="开发者账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'devAccount', validatorRules.devAccount]" placeholder="请输入开发者账号"></a-input>
        </a-form-item>
        <a-form-item label="开发者密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'devPassword', validatorRules.devPassword]" placeholder="请输入开发者密码"></a-input>
        </a-form-item>
        <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'companyName', validatorRules.companyName]" placeholder="请输入公司名称"></a-input>
        </a-form-item>
        <a-form-item label="企业微信appID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'qywxAgentId', validatorRules.qywxAgentId]" placeholder="请输入企业微信appID"></a-input>
        </a-form-item>
        <a-form-item label="企业微信appSecret" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'qywxAgentSecret', validatorRules.qywxAgentSecret]" placeholder="请输入企业微信appSecret"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['izState', validatorRules.izState]" :trigger-change="true" dictCode="user_status" placeholder="请选择是否启用"/>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  
  export default {
    name: "BusGisWechatDeveloperAccountsModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          devAccount: {rules: [
          ]},
          devPassword: {rules: [
          ]},
          companyName: {rules: [
          ]},
          qywxAgentId: {rules: [
          ]},
          qywxAgentSecret: {rules: [
          ]},
          izState: {rules: [
          ]},
        },
        url: {
          add: "/wechat.base/busGisWechatDeveloperAccounts/add",
          edit: "/wechat.base/busGisWechatDeveloperAccounts/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'devAccount','devPassword','companyName','qywxAgentId','qywxAgentSecret','izState'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'devAccount','devPassword','companyName','qywxAgentId','qywxAgentSecret','izState'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>